<div class="apps-menu gap-12">
  @if (isWebAllowed) {
    <a
      (click)="onSwitchApp(webUrl)"
      [class.active]="isActive('web')"
      class="menu-item flex-col gap-8 start-center"
    >
      <span class="icon ui-icon-object-camera"></span>
      <span class="label">{{ 'UI.APPS_MENU.VMS' | translate }}</span>
    </a>
  }
  @if (isControlCenterAllowed) {
    <a
      (click)="onSwitchApp(controlCenterUrl)"
      [class.active]="isActive('control-center')"
      class="menu-item flex-col gap-8 start-center"
    >
      <span class="icon ui-icon-armed"></span>
      <span class="label">{{ 'UI.APPS_MENU.CONTROL_CENTER' | translate }}</span>
    </a>
  }
  @if (isParkingAllowed) {
    <a
      (click)="onSwitchApp(parkingUrl)"
      [class.active]="isActive('parking')"
      class="menu-item flex-col gap-8 start-center"
    >
      <span class="icon ui-icon-parking-traffic-violations"></span>
      <span class="label">{{
        'UI.APPS_MENU.TRAFFIC_AND_PARKING' | translate
      }}</span>
    </a>
  }
  @if (isPanicAllowed) {
    <a
      (click)="onSwitchApp(panicUrl)"
      [class.active]="isActive('panic')"
      class="menu-item flex-col gap-8 start-center"
    >
      <span class="icon ui-icon-add-alarm"></span>
      <span class="label">{{ 'UI.APPS_MENU.PANIC' | translate }}</span>
    </a>
  }
  @if (isChatAllowed && chatUrl) {
    <a
      (click)="onSwitchApp(chatUrl)"
      [class.active]="isActive('chat')"
      class="menu-item flex-col gap-8 start-center"
    >
      <span class="icon ui-icon-chat"></span>
      <span class="label">{{ 'UI.APPS_MENU.CHAT' | translate }}</span>
    </a>
  }
  <!--  @if (isSitePlannerAllowed) {-->
  <!--    <a-->
  <!--      (click)="onSwitchApp(sitePlannerUrl)"-->
  <!--      [class.active]="isActive('site-planner')"-->
  <!--      class="menu-item flex-col gap-8 start-center"-->
  <!--    >-->
  <!--      <span class="icon ui-icon-partner-portal"></span>-->
  <!--      <span class="label">{{ 'UI.APPS_MENU.PARTNER_PORTAL' | translate }}</span>-->
  <!--    </a>-->
  <!--  }-->
</div>
